
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wellness/[slug]",
      function () {
        return require("private-next-pages/wellness/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wellness/[slug]"])
      });
    }
  